import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import IntroductionSection from './components/IntroductionSection';
import QuizSection from './components/QuizSection';
import ResultSection from './components/ResultSection';
import SuggestionsSection from './components/SuggestionsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [quizAnswers, setQuizAnswers] = useState<Record<number, string>>({});
  const [userName, setUserName] = useState('');
  const [showResult, setShowResult] = useState(false);

  const handleQuizComplete = (answers: Record<number, string>, name: string) => {
    setQuizAnswers(answers);
    setUserName(name);
    setShowResult(true);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <IntroductionSection />
      <QuizSection onComplete={handleQuizComplete} />
      <ResultSection answers={quizAnswers} userName={userName} isVisible={showResult} />
      <SuggestionsSection />
      <ContactSection formUrl="https://readdy.ai/api/form/d5htuobihlvellpk56eg" />
      <Footer />
    </div>
  );
}